import type { Dispatch } from '@reduxjs/toolkit'

import type { TokenStorage } from './token-storage'
import { invalidateVerifiedProfile } from './verified-profile'
import {
  sessionBecameAnonymous,
  sessionBecameAuthenticated,
} from './session-slice'

export function initializeSession(
  dispatch: Dispatch,
  tokenStorage: TokenStorage,
) {
  dispatch(
    tokenStorage.read()
      ? sessionBecameAuthenticated()
      : sessionBecameAnonymous(),
  )
}

export function establishSession(
  dispatch: Dispatch,
  tokenStorage: TokenStorage,
  token: string,
) {
  invalidateVerifiedProfile()
  tokenStorage.write(token)
  dispatch(sessionBecameAuthenticated())
}

export function endSession(dispatch: Dispatch, tokenStorage: TokenStorage) {
  invalidateVerifiedProfile()
  tokenStorage.clear()
  dispatch(sessionBecameAnonymous())
}
